import {FC} from "react";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {IFanVote} from "modules/types";
import {getPlayerById} from "modules/selectors";
import {getPlayerAvatarSrc, getPlayerName} from "modules/utils";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 282px;
	width: 100%;
	padding: 20px;

	img {
		width: 100%;
	}
`;

const Name = styled.div`
	font-size: 32px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;
	margin-top: 8px;
	margin-bottom: 20px;
`;

export const HistoryVotePlayer: FC<IFanVote> = ({player: playerId}) => {
	const player = useSelector(getPlayerById)(playerId);

	if (!player) {
		return null;
	}

	return (
		<Wrapper>
			<img src={getPlayerAvatarSrc(player)} alt={getPlayerName(player)} />

			<Name>{getPlayerName(player)}</Name>
		</Wrapper>
	);
};
